import moment from 'moment';
import { IComment } from '../../core/helpers/interfaces/comment';
import {
	GET_COMMENTS,
	GET_COMMENTS_SUCCESS,
	GET_COMMENTS_FAILURE,
	RESET_COMMENTS,
	ADD_COMMENT_SUCCESS,
} from './types';

export const defaultState = {
	data: [] as IComment[],
	isLoading: true,
	isLoaded: false,
	error: null,
	type: null,
};

export type ICommentsState = typeof defaultState;

export const comments = (state = defaultState, action: any): ICommentsState => {
	const { type, payload } = action;
	switch (type) {
		case GET_COMMENTS:
			return {
				...state,
				isLoading: true,
				error: null,
				type,
			};
		case GET_COMMENTS_SUCCESS:
			return {
				...state,
				data: payload,
				isLoading: false,
				isLoaded: true,
				error: null,
				type,
			};
		case GET_COMMENTS_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: payload,
				type,
			};
		case RESET_COMMENTS:
			return {
				...state,
				isLoading: true,
				type,
			};
		case ADD_COMMENT_SUCCESS:
			return {
				...state,
				data: [...state.data, { ...payload, createdAt: moment().valueOf() }],
				type,
			};
		default:
			return state;
	}
};
